import { useEffect, useState,useRef } from "react";
import styled from "styled-components";
import axios from "axios";
import Loader from '../components/Loader';
import FilterBar from "../components/filterBar";
import * as XLSX from "xlsx";
import jsPDF from "jspdf";
import autoTable from "jspdf-autotable";
import { useNavigate } from "react-router-dom";

// import MainHeader from "../components/MainHeader";
const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;

 const Row = styled.div`
  display: flex;
  gap: 22px;
  margin-bottom: 0.3rem;
`;

const Select = styled.select`
  flex: 1;
  width: 100%;
  border: 1px solid #D9D9D9;
  border-radius: 9px;
  height: 40px;
  font-size: 1rem;
  padding: 0 12px;
  margin-bottom: 1.04rem;
  background: #fff;
  font-family: 'Inter', Arial, sans-serif;
  &:focus {
    border-color: #3772FF;
    outline: none;
  }
`;
const Page = styled.div`
  min-height: 100vh;
  background: #f6f8fb;
  font-family: 'Segoe UI', 'Inter', Arial, sans-serif;
`;


const Container = styled.div`
  max-width: 1400px;
  margin: 0 auto;
  padding: 24px 18px 32px;
`;


const PageTitle = styled.h2`
  font-size: 1.6rem;
  font-weight: 700;
  color: #21325b;
  margin-bottom: 18px;
`;


const TabContainer = styled.div`
  display: flex;
  border-bottom: 2px solid #ddd;
  margin-bottom: 20px;
`;


const Tab = styled.button`
  padding: 12px 24px;
  font-weight: 600;
  font-size: 1rem;
  cursor: pointer;
  border: none;
  border-bottom: ${({ active }) => (active ? '3px solid #3772FF' : 'none')};
  color: ${({ active }) => (active ? '#3772FF' : '#777')};
  background: none;
  outline: none;
`;


const TableCard = styled.div`
  background: #fff;
  border-radius: 14px;
  box-shadow: 0 2px 10px rgba(35,62,88,0.06);
  padding: 20px;
`;


const Table = styled.table`
  width: 100%;
  border-collapse: collapse;
  th, td {
    text-align: left;
    padding: 12px 16px;
    border-bottom: 1px solid #eee;
  }
  th {
    font-weight: 600;
    color: #2b3b5f;
  }
`;


const Button = styled.button`
  background: #3772FF;
  color: #fff;
  border: none;
  border-radius: 8px;
  padding: 0.3rem 1.2rem;
  min-width: 80px;
  font-weight: 600;
  font-size: 0.9rem;
  cursor: pointer;
  box-shadow: 0 1px 2px rgba(35,62,88,0.05);
  &:hover {
    background: #245bb9;
  }
  margin: 0 2px;
`;


const FormRow = styled.div`
  display: flex;
  gap: 12px;
  align-items: center;
  margin-bottom: 12px;
`;


const Label = styled.label`
  flex: 3;
  font-weight: 600;
  color: #21325b;
`;
const FormLabel = styled.label`
  flex: 5;
  font-weight: 700;
  font-size : 1.5rem;
  color: #21325b;
`;
const Unit = styled.div`
  flex: 1;
  color: #555;
`;


const Input = styled.input`
  flex: 1;
  padding: 6px 10px;
  border-radius: 8px;
  border: 1px solid #dcdcdc;
  font-size: 1rem;
`;


const DoubleInputContainer = styled.div`
  flex: 2;
  display: flex;
  gap: 8px;
`;


const ErrorText = styled.div`
  color: #d24949;
  margin: 10px 0;
`;


const ModalOverlay = styled.div`
  position: fixed;
  top: 0; left: 0;
  width: 100%; height: 100%;
  background: rgba(0,0,0,0.4);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1000;
`;


const ModalContainer = styled.div`
  background: #fff;
  border-radius: 14px;
  width: 900px;
  max-width: 100%;
  max-height: 80%;
  padding: 20px 25px;
  overflow-y: auto;
  box-shadow: 0 6px 20px rgba(0,0,0,0.25);
`;


const ModalHeader = styled.h3`
  margin-top: 0;
  margin-bottom: 20px;
  color: #21325b;
`;


const EntryRow = styled.div`
  display: flex;
  padding: 8px 0;
  border-bottom: 1px solid #eee;
`;


const EntryLabel = styled.div`
  flex: 1;
  font-weight: 600;
  color: #425466;
`;


const EntryValue = styled.div`
  flex: 4;
  color: #556987;
  text-align: center;
`;


export default function InventoryEntriesPage() {
  const userData = {
    user: JSON.parse(localStorage.getItem('user')),
    token: localStorage.getItem('access_token'),
  };

    const fileInputRef = useRef(null);

  const isAdmin = userData.user.roles.role_name === "SUPER_ADMIN";
  const isStoreManager = userData.user.roles.role_name == "STORE_MANAGER"

  const [stores,setStores] = useState([]);
  const [location,setLocation] = useState(isAdmin?'' : userData.user.store_id);
  const headers = { Authorization: `Bearer ${userData.token}` };
  const [entryCheckFlag,setEntryCheckFlag] = useState(false);
  const [activeTab, setActiveTab] = useState(isAdmin || isStoreManager?'list':'form');
    const [allEntries, setAllEntries] = useState([]);

  const [entries, setEntries] = useState([]);
  const [products, setProducts] = useState([]);
  const [categories, setCategories] = useState([]);
   const [allProducts, setAllProducts] = useState([]);
  const [allCategories, setAllCategories] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  const [entryDate, setEntryDate] = useState(new Date().toISOString().split('T')[0]);
  const [itemCount, setItemCount] = useState({}); // { productId: {ordered, balance} }
  const navigate = useNavigate()
  // Modal state
  const [viewModalOpen, setViewModalOpen] = useState(false);
  const [viewEntry, setViewEntry] = useState(null);
const [filterText, setFilterText] = useState("");
const [filterFromDate, setFilterFromDate] = useState(null);
const [filterToDate, setFilterToDate] = useState(null);
const [sortField, setSortField] = useState(null);
const [sortOrder, setSortOrder] = useState(null);
useEffect(()=>{
 if(!isAdmin && !isStoreManager)
  navigate('/')
},[])
useEffect(() => {
  let filtered = allEntries;

  // Text filter matches store name, created by or user name fields
  if (filterText) {
    const lowerSearch = filterText.toLowerCase();
    filtered = filtered.filter(entry =>
      entry.store_data?.friendly_name?.toLowerCase().includes(lowerSearch) ||
      entry.store_data?.city?.toLowerCase().includes(lowerSearch) ||
      entry.store_data?.state?.toLowerCase().includes(lowerSearch) ||
      entry.user_data?.first_name?.toLowerCase().includes(lowerSearch) ||
      entry.user_data?.last_name?.toLowerCase().includes(lowerSearch)
    );
  }

  // Date filter on entry date
  if (filterFromDate || filterToDate) {
    filtered = filtered.filter(entry => {
      const entryDateObj = new Date(entry.date);
      const from = filterFromDate ? new Date(filterFromDate) : null;
      const to = filterToDate ? new Date(filterToDate) : null;
      return (!from || entryDateObj >= from) && (!to || entryDateObj <= to);
    });
  }

  // Sort, including sorting by store friendly_name or other nested fields
  if (sortField && sortOrder) {
    const getValue = (obj, path) => {
      return path.split('.').reduce((o, key) => (o ? o[key] : ''), obj) || '';
    };
    filtered = [...filtered].sort((a, b) => {
      let aVal = getValue(a, sortField);
      let bVal = getValue(b, sortField);

      // Attempt date conversion for date fields
      if (sortField === "date") {
        aVal = new Date(aVal);
        bVal = new Date(bVal);
      }
      if (aVal < bVal) return sortOrder === "asc" ? -1 : 1;
      if (aVal > bVal) return sortOrder === "asc" ? 1 : -1;
      return 0;
    });
  }

  setEntries(filtered);
}, [allEntries, filterText, filterFromDate, filterToDate, sortField, sortOrder]);
 const handleFileUpload = async (e) => {
    const file = e.target.files[0];
    if (!file) return;

    const formData = new FormData();
    formData.append('file', file);

    try {
      const res = await axios.post(`${BACKEND_URL}/inventory/entry/bulk-upload`, formData, {
        headers: {
          'Content-Type': 'multipart/form-data',
          Authorization: `Bearer ${userData.token}`
        }
      });
      alert(`${res.data.message} (${res.data.count} entries uploaded)`);
      fetchEntriesAndStores(); // refresh your data after successful upload
    } catch (err) {
      alert('Upload failed: ' + (err.response?.data?.error || err.message));
    } finally {
      e.target.value = null; // reset file input
    }
  };
const handleTextFilter = (text) => setFilterText(text || "");
const handleDateFilter = (from, to) => {
  setFilterFromDate(from || null);
  setFilterToDate(to || null);
};
const handleSortChange = (field, order) => {
  setSortField(field);
  setSortOrder(order);
};
const handleResetFilters = () => {
  setFilterText("");
  setFilterFromDate(null);
  setFilterToDate(null);
  setSortField(null);
  setSortOrder(null);
};

  const checkEntryExistsForTodayandStore =  (entryList,entryDate,store_id) => {
    try {
      const todayStr = entryDate || new Date().toISOString().split('T')[0];
      if (entryList && Array.isArray(entryList)) {
        return entryList.some(entry => entry.date === todayStr && entry.store_id == store_id);
      }
      return false;
    } catch (err) {
      console.error('Error checking entry for today:', err);
      return false;
    }
  };

  const fetchEntriesAndStores = async () => {
    try {
      setLoading(true);
      const [res,storesRes] = await Promise.all([
          axios.get(`${BACKEND_URL}/inventory/entry/all`, { headers }),
          axios.get(`${BACKEND_URL}/store`, { headers }),
      ]);
            setAllEntries(res.data);

      setEntries(res.data);
      setStores(storesRes.data);
      setEntryCheckFlag(checkEntryExistsForTodayandStore(res.data, entryDate, location));
    } catch (err) {
      setError('Failed to fetch entries');
    } finally {
      setLoading(false);
    }
  };


  const fetchProducts = async () => {
    try {
      const res = await axios.get(`${BACKEND_URL}/inventory/all`, { headers });
      setAllProducts(res.data)
      setProducts(res.data.filter(item => item.is_deleted == false));
      // Initialize itemCount with empty ordered and balance for each product:
      const initCounts = {};
      res.data.filter(item => item.is_deleted == false).forEach(p => {
        initCounts[p.id] = { ordered: '', balance: '' };
      });
      setItemCount(initCounts);
    } catch (err) {
      setError('Failed to fetch products');
    }
  };

  const fetchCategories = async () => {
    try {
      const res = await axios.get(`${BACKEND_URL}/categories/all`, { headers });
      if (res.status === 200) {
        setAllCategories(res.data)
        setCategories(res.data.filter(item => item.is_deleted == false));
      }
    } catch (err) {
      setError('Failed to fetch categories');
    }
  };

  useEffect(() => {
    fetchEntriesAndStores();
    fetchProducts();
    fetchCategories();
  }, []);

 const handleInputChange = (productId, field, value) => {
  // Remove all minus signs from the value
  const sanitizedValue = value.replace(/-/g, '');

  // Allow empty input (for clearing)
  if (sanitizedValue === '') {
    setItemCount(prev => ({
      ...prev,
      [productId]: {
        ...prev[productId],
        [field]: '',
      },
    }));
    return;
  }

  // Allow only digits and optional single decimal point
  const regex = /^\d*\.?\d*$/;

  if (regex.test(sanitizedValue)) {
    setItemCount(prev => ({
      ...prev,
      [productId]: {
        ...prev[productId],
        [field]: sanitizedValue,
      },
    }));
  }
  // Ignore any other invalid inputs
};



  const handleSubmit = async () => {
    setError('');
    if(!location){
      setError('Please select store to continue');
      return;
    }
    const filteredCounts = {};
    for (const key in itemCount) {
      const orderedVal = parseFloat(itemCount[key].ordered);
      const balanceVal = parseFloat(itemCount[key].balance);
      if (
        (!isNaN(orderedVal) && orderedVal >= 0) ||
        (!isNaN(balanceVal) && balanceVal >= 0)
      ) {
        filteredCounts[key] = {
          ordered: !isNaN(orderedVal) && orderedVal >= 0 ? orderedVal : 0,
          balance: !isNaN(balanceVal) && balanceVal >= 0 ? balanceVal : 0,
        };
      }
    }
    if (Object.keys(filteredCounts).length === 0) {
      setError('Please enter at least one ordered or balance amount');
      return;
    }

    try {
      setLoading(true);
      const res = await axios.post(
        `${BACKEND_URL}/inventory/entry/create`,
        { date: entryDate, item_count: filteredCounts ,store_id : Number(location),user_id :userData.user.id},
        { headers }
      );
      if(res.error){
        alert(res.error)
      }
      const resetCounts = {};
      products.forEach((p) => {
        resetCounts[p.id] = { ordered: '', balance: '' };
      });
      setItemCount(resetCounts);
      setEntryDate(new Date().toISOString().split('T')[0]);
      fetchEntriesAndStores();
      setActiveTab('list');
    } catch (err) {
      setError('Failed to submit entry');
    } finally {
      setLoading(false);
    }
  };

  // Modal open to view details
  const openViewModal = (entry) => {
    setViewEntry(entry);
    setViewModalOpen(true);
  };

  const getProductById = (id) => allProducts.find((p) => p.id === Number(id));

  // Group products by category including empty categories
  const productsByCategory = categories.reduce((acc, cat) => {
    acc[cat.id] = [];
    return acc;
  }, {});

  products.forEach(product => {
    if (product.category_id && productsByCategory[product.category_id]) {
      productsByCategory[product.category_id].push(product);
    } else {
      if (!productsByCategory[0]) productsByCategory[0] = [];
      productsByCategory[0].push(product);
    }
  });
 const exportToExcel = () => {
  const data = [];

  entries.forEach(entry => {
    const baseRow = {
      "Entry ID": entry.id,
      Date: entry.date,
      "Store Name": entry.store_data ? `${entry.store_data.friendly_name}, ${entry.store_data.city}, ${entry.store_data.state}` : "",
      "Created By": entry.user_data ? `${entry.user_data.first_name} ${entry.user_data.last_name}` : "",
      "Products Count": entry.item_count ? Object.keys(entry.item_count).length : 0,
    };

    // Add one column for each product in allProducts
    allProducts.forEach(product => {
      const item = entry.item_count ? entry.item_count[product.id] : null;
      baseRow[product.name] = item ? `Re-Ordered: ${item.ordered}, In-Stock: ${item.balance}` : "";
    });

    data.push(baseRow);
  });

  const worksheet = XLSX.utils.json_to_sheet(data);
  const workbook = XLSX.utils.book_new();
  XLSX.utils.book_append_sheet(workbook, worksheet, "Inventory Entries");
  XLSX.writeFile(workbook, "inventory_entries_export.xlsx");
};

const exportToPDF = () => {
  const doc = new jsPDF();

  const fixedColumns = [
    { header: "Entry ID", dataKey: "entryId" },
    { header: "Date", dataKey: "date" },
    { header: "Store Name", dataKey: "storeName" },
    { header: "Created By", dataKey: "createdBy" },
    { header: "Products Count", dataKey: "productsCount" },
  ];

  // Add a column for each product
  const productColumns = allProducts.map(product => ({
    header: product.name,
    dataKey: product.name
  }));

  const columns = [...fixedColumns, ...productColumns];

  const rows = entries.map(entry => {
    const baseRow = {
      entryId: entry.id,
      date: entry.date,
      storeName: entry.store_data ? `${entry.store_data.friendly_name}, ${entry.store_data.city}, ${entry.store_data.state}` : "",
      createdBy: entry.user_data ? `${entry.user_data.first_name} ${entry.user_data.last_name}` : "",
      productsCount: entry.item_count ? Object.keys(entry.item_count).length : 0,
    };

    allProducts.forEach(product => {
      const item = entry.item_count ? entry.item_count[product.id] : null;
      baseRow[product.name] = item ? `Re-Ordered: ${item.ordered}, In-Stock: ${item.balance}` : "";
    });

    return baseRow;
  });

  autoTable(doc, { columns, body: rows, margin: { top: 10 }, styles: { fontSize: 8 } });
  doc.save("inventory_entries_export.pdf");
};


  return (
    <>
      {/* <MainHeader /> */}
      {loading && <Loader/>}
      <Page>
        <Container>
          <PageTitle>Inventory Entries</PageTitle>
          <TabContainer>
            {(isAdmin  || isStoreManager)&& <Tab active={activeTab === 'list'} onClick={() => setActiveTab('list')}>
              Entry List
            </Tab>}
            <Tab active={activeTab === 'form'}
              onClick={() => setActiveTab('form')}>
              Entry Form
            </Tab>
          </TabContainer>

          {activeTab === 'list' && (isAdmin || isStoreManager) && (
            <TableCard>
              <Row>
                <FilterBar
  placeholder="Search inventory entries..."
  sortFields={[
    { value: "date", label: "Entry Date" },
    { value: "store_data.friendly_name", label: "Store Name" },
    { value: "user_data.first_name", label: "Created By First Name" },
    { value: "user_data.last_name", label: "Created By Last Name" },
  ]}
  onTextFilter={handleTextFilter}
  onDateFilter={handleDateFilter}
  onSortChange={handleSortChange}
  onResetFilters={handleResetFilters}
   onExportPDF={exportToPDF}
  onExportExcel={exportToExcel}
/>

              </Row>
              <Table>
                <thead>
                  <tr>
                    <th>ID</th>
                    <th>Date</th>
                    <th>Store Name</th>
                    <th>Created By</th>
                    <th>Products Count</th>
                    <th>Action</th>
                  </tr>
                </thead>
                <tbody>
                  {entries.length === 0 ? (
                    <tr>
                      <td colSpan={8} style={{ textAlign: "center" }}>
                        No entries found
                      </td>
                    </tr>
                  ) : (
                    entries.map((entry) => {
                      if(isAdmin || userData.user.store_id == entry.store_id)
                     return <tr key={entry.id}>
                        <td>{entry.id}</td>
                        <td>{entry.date}</td>
                        <td>{`${entry.store_data.friendly_name},${entry.store_data.city},${entry.store_data.state}`}</td>
                        <td>{`${entry.user_data.first_name} ${entry.user_data.last_name}`}</td>
                        <td>
                          {entry.item_count ? Object.keys(entry.item_count).length : 0}
                        </td>
                        <td>
                          <Button onClick={() => openViewModal(entry)}>View</Button>
                        </td>
                      </tr>
                    }
                  
                  )
                  )}
                </tbody>
              </Table>
            </TableCard>
          )}

          {activeTab === "form" && (
            <TableCard>
              <FormRow>
                  {/* <input
        type="file"
        accept=".xls,.xlsx"
        style={{ display: 'none' }}
        ref={fileInputRef}
        onChange={handleFileUpload}
      />
      <Button onClick={() => fileInputRef.current?.click()}>
        Bulk Upload Excel
      </Button> */}
              </FormRow>
              <FormRow>
                
                <Label>Location<span style={{ color: 'red', marginLeft: '4px' }}>*</span></Label>
                <Select
                  disabled={!isAdmin}
                  name="location"
                  value={location}
                  onChange={(e)=> {
                    setLocation(e.target.value);
                    setEntryCheckFlag(checkEntryExistsForTodayandStore(entries,entryDate,e.target.value));
                  }}
                  required
                >
                  <option value="" disabled={isAdmin}>
                    Select Store
                  </option>
                  {stores.map((store) => (
                    <option key={store.id} value={store.id}>
                      {store.friendly_name}, {store.city}, {store.state}
                    </option>
                  ))}
                </Select>
              </FormRow>
              <FormRow>
                <Label htmlFor="entryDate">Date:<span style={{ color: 'red', marginLeft: '4px' }}>*</span></Label>
                <Input
                  type="date"
                  id="entryDate"
                  value={entryDate}
                  max={new Date().toISOString().split("T")[0]}
                  onChange={(e) =>{
                     setEntryDate(e.target.value);
                     setEntryCheckFlag(checkEntryExistsForTodayandStore(entries,e.target.value,location));
                  }}
                />
              </FormRow>

              {categories.length === 0 ? (
                <div>Loading categories...</div>
              ) : (
                <>
                  <FormRow>
                    <FormLabel>Item List<span style={{ color: 'red', marginLeft: '4px' }}>*</span></FormLabel>
                  </FormRow>

                  {categories.map(cat => (
                    <div key={cat.id} style={{ marginBottom: '2rem' }}>
                      <h3>{cat.category_name}{cat.category_description ? `: (${cat.category_description})` : ''}</h3>
                      {(productsByCategory[cat.id] && productsByCategory[cat.id].length > 0) ? (
                        productsByCategory[cat.id].map(({ id, name, metric }) => (
                          <FormRow key={id}>
                            <Label>{name}</Label>
                            <Unit>{metric}</Unit>
                            <DoubleInputContainer>
                              <Input
                                type="number"
                                min="0"
                                step="any"
                                value={itemCount[id]?.ordered || ""}
                                onChange={(e) => handleInputChange(id, "ordered", e.target.value)}
                                placeholder="Re-Ordered"
                              />
                              <Input
                                type="number"
                                min="0"
                                step="any"
                                value={itemCount[id]?.balance || ""}
                                onChange={(e) => handleInputChange(id, "balance", e.target.value)}
                                placeholder="In-Stock"
                              />
                            </DoubleInputContainer>
                          </FormRow>
                        ))
                      ) : (
                        <div style={{ color: '#555', fontStyle: 'italic', paddingLeft: '1rem' }}>No products in this category</div>
                      )}
                    </div>
                  ))}

                  {error && <ErrorText>{error}</ErrorText>}
                  <Label style={{ marginBottom: '20px', marginTop: '40px' }}>
                    <span style={{ color: 'red', marginLeft: '4px' }}>*</span> marked fields are required.
                  </Label>

                  <div>
                    <Button onClick={handleSubmit} disabled={loading || entryCheckFlag}
                      style={{
                        cursor: entryCheckFlag ? 'not-allowed' : 'pointer',
                        color: entryCheckFlag ? '#666' : '',
                        background : entryCheckFlag ? '#999' : '',
                        border: 'none',
                        padding: '10px 16px',
                        borderRadius: '4px',
                        fontWeight: '600',
                        marginTop : '20px'
                      }}
                    >
                      {loading ? "Submitting..." : "Submit Entry"}
                    </Button>
                  </div>
                </>
              )}
            </TableCard>
          )}

         {viewModalOpen && viewEntry && (
  <ModalOverlay onClick={() => setViewModalOpen(false)}>
    <ModalContainer onClick={(e) => e.stopPropagation()}>
      <ModalHeader>
        Inventory Entry #{viewEntry.id} - {viewEntry.date}
      </ModalHeader>

      {/* Group products in this entry by category */}
      {(() => {
        if (!viewEntry.item_count) return <div>No products in this entry.</div>;
        
        // Group product IDs by category id
        const productIds = Object.keys(viewEntry.item_count);
        const productsInEntry = productIds.map(pid => getProductById(pid)).filter(Boolean);

        // Create categoryId => [products] map
        const productsGroupedByCategory = {};
        categories.forEach(cat => {
          productsGroupedByCategory[cat.id] = [];
        });
        // For uncategorized products
        productsGroupedByCategory[0] = [];

        productsInEntry.forEach(prod => {
          if (prod.category_id && productsGroupedByCategory[prod.category_id]) {
            productsGroupedByCategory[prod.category_id].push(prod);
          } else {
            productsGroupedByCategory[0].push(prod);
          }
        });

        return Object.entries(productsGroupedByCategory).map(([catId, prods]) => {
          if (prods.length === 0) return null;
          const category = categories.find(c => c.id === Number(catId)) || { category_name: 'Uncategorized', category_description: '' };
          return (
            <div key={catId} style={{ marginBottom: '1.5rem' }}>
              <h4 style={{ marginBottom: '0.4rem' }}>
                {category.category_name}
                {category.category_description ? `: (${category.category_description})` : ''}
              </h4>
              {prods.map(product => {
                const { ordered = 0, balance = 0 } = viewEntry.item_count[product.id] || {};
                return (
                  <EntryRow key={product.id}>
                    <EntryLabel>{product.name}</EntryLabel>
                    <Unit>{product.metric}</Unit>
                    <EntryValue>
                      Re-Ordered: {ordered} &nbsp;&nbsp; In-Stock: {balance}
                    </EntryValue>
                  </EntryRow>
                );
              })}
            </div>
          );
        });
      })()}

      <div style={{ textAlign: "right", marginTop: 20 }}>
        <Button onClick={() => setViewModalOpen(false)}>Close</Button>
      </div>
    </ModalContainer>
  </ModalOverlay>
)}

        </Container>
      </Page>
    </>
  );
}
